/**
 * @description 抽獎資格檢核時機
 */
export enum GamePOI {
  /** 註冊完成且勾選EDM */
  REG = 'REG',
  /** 投保 */
  INSURE = 'INSURE'
}
